import { render, staticRenderFns } from "./personalCertification.vue?vue&type=template&id=b2244a96&scoped=true"
import script from "./personalCertification.vue?vue&type=script&lang=js"
export * from "./personalCertification.vue?vue&type=script&lang=js"
import style0 from "./personalCertification.vue?vue&type=style&index=0&id=b2244a96&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2244a96",
  null
  
)

export default component.exports